import { render, staticRenderFns } from "./StopTrafficLightForm.vue?vue&type=template&id=6a247432&"
import script from "./StopTrafficLightForm.vue?vue&type=script&lang=js&"
export * from "./StopTrafficLightForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports